import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-escaltion-modal',
  templateUrl: './escaltion-modal.component.html',
  styleUrls: ['./escaltion-modal.component.scss']
})
export class EscalationModalComponent implements OnInit {

  reasons = ['UBER', 'DISTANCE', 'RISK', 'DRIVER', 'PARCEL SIZE', 'PNP'];
  selectedReason = null;

  constructor(private dialogRef: MatDialogRef<EscalationModalComponent>) { }

  ngOnInit(): void {
  }

  applyChanges(): void{
    // do more
    this.dialogRef.close(this.selectedReason);
  }

}
